import styled from 'styled-components';

export const RowItem = styled.td`
  text-align: center;
  font-size: 12px;
  font-weight: 700;
  color: #707070;
`;
